import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

export const useIsReadOnly = (planId: string) => {
  const { data: operationalPlanData, isLoading } = usePlanDetails(planId)
  if (operationalPlanData === undefined) {
    return { readOnly: true, isPlanReadOnlyLoading: isLoading }
  }

  if (operationalPlanData) {
    const { planAccessType } = operationalPlanData
    try {
      const { readonly } = JSON.parse(planAccessType)
      return { readOnly: readonly, isPlanReadOnlyLoading: isLoading }
    } catch (e) {
      return { readOnly: false, isPlanReadOnlyLoading: isLoading }
    }
  }

  return { readOnly: true, isPlanReadOnlyLoading: isLoading }
}

const usePlanDetails = (planId: string) => {
  return useQuery(
    ['plan-details-user-access', planId],
    () => request({ url: `/operational-plan/${planId}` }),
    {
      cacheTime: 60 * 60 * 24,
      select: (response) => response?.data?.data,
    }
  )
}
